import React from 'react';
import Main from './main-component';
const Cms = ({name}) => {
    return (
        <div className='cms-page'>
            <Main data_key={name} />
        </div >
    );
}
export default Cms;
